export default __webpack_public_path__ + "static/media/complete.c76a8a8c.svg";